import React from "react";
import { Modal, Tag, Typography, Empty } from "antd";
import {
    TagsOutlined,
    PlusCircleOutlined,
    SyncOutlined,
    ToolOutlined,
} from "@ant-design/icons";
import changelogData from "../data/changelogData";
import { APP_VERSION } from "../version";

const { Title, Text } = Typography;

const SECTIONS = [
    { key: "added", label: "Added", color: "green", icon: <PlusCircleOutlined /> },
    { key: "changed", label: "Changed", color: "blue", icon: <SyncOutlined /> },
    { key: "fixed", label: "Fixed", color: "orange", icon: <ToolOutlined /> },
];

export default function ChangelogModal({ open, onClose }) {
    return (
        <Modal
            title={
                <span>
                    <TagsOutlined style={{ color: "#0d9488", marginRight: 8 }} />
                    What's New in StoreHub
                </span>
            }
            open={open}
            onCancel={onClose}
            footer={null}
            width={640}
        >
            {changelogData.length === 0 ? (
                <Empty description="No changelog entries yet" />
            ) : (
                changelogData.map((release, idx) => (
                    <div
                        key={release.version}
                        style={{
                            paddingBottom: 16,
                            marginBottom: 16,
                            borderBottom: idx === changelogData.length - 1 ? "none" : "1px solid #f0f0f0",
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
                            <Title level={5} style={{ margin: 0 }}>
                                v{release.version}
                            </Title>
                            {release.version === APP_VERSION && <Tag color="teal">Current</Tag>}
                            <Text type="secondary" style={{ fontSize: 12 }}>{release.date}</Text>
                        </div>

                        {SECTIONS.map(({ key, label, color, icon }) => {
                            const items = release[key];
                            if (!items || items.length === 0) return null;
                            return (
                                <div key={key} style={{ marginBottom: 8 }}>
                                    <Tag color={color} icon={icon} style={{ marginBottom: 6 }}>{label}</Tag>
                                    <ul style={{ margin: 0, paddingLeft: 22 }}>
                                        {items.map((line, i) => (
                                            <li key={i} style={{ fontSize: 13, color: "#4a5568", marginBottom: 4 }}>
                                                {line}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            );
                        })}
                    </div>
                ))
            )}
        </Modal>
    );
}
